import { getImageThumbnailUrl } from './getImageThumbnailUrl'

export function getGenericVideoThumbnailUrl(medias) {
  const firstImageTypeMedia = medias.find(media => media.visualType === 'ItemImage')
  if (firstImageTypeMedia) {
    return getImageThumbnailUrl(firstImageTypeMedia)
  }

  return ''
}
